import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Outlet } from "@tanstack/react-router";
// UI
import { Container, Anchor } from "@mantine/core";
// components
import { PageHeader } from "@components/page-header/page-header";
// assets
import css from "./password-reset-layout.module.css";
import { useFooterUrls } from "@pages/start/layout/layout";

const Footer = React.memo(function Footer() {
  const { t } = useTranslation();
  const { contactUrl } = useFooterUrls();
  return (
    <footer className={css["footer-container"]}>
      <Trans
        i18nKey="passwordReset.common.footerTextWithLink"
        t={t}
        components={{
          Link: (
            <Anchor
              className={css["footer-link"]}
              href={contactUrl}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    </footer>
  );
});

export const PasswordResetLayout = React.memo(function PasswordResetLayout() {
  return (
    <>
      <PageHeader />

      <Container className={css["main-content-container"]}>
        <Outlet />
      </Container>

      <Footer />
    </>
  );
});
